module.exports = __webpack_public_path__ + "img/long.de11a394.png";